module.exports = {
  "pageview": {
    "name": "pageview",
    "class": "view",
    "properties": {
      "screen": [
        "details",
        "directory",
        "manage-purchases",
        "provider-signup"
      ]
    },
    "namespace": "marketplace"
  },
  "purchased-good": {
    "name": "purchased-good",
    "class": "interaction",
    "properties": {
      "screen": "string",
      "value_str": "string",
      "value": "number",
      "payment_type": [
        "free",
        "stripe",
        "paypal"
      ],
      "is_trial": "boolean"
    },
    "namespace": "marketplace"
  },
  "uninstall-good": {
    "name": "uninstall-good",
    "class": "interaction",
    "properties": {
      "screen": "string"
    },
    "namespace": "marketplace"
  },
  "redeliver-good": {
    "name": "redeliver-good",
    "class": "interaction",
    "properties": {
      "screen": "string"
    },
    "namespace": "marketplace"
  },
  "clicked-link": {
    "name": "clicked-link",
    "class": "interaction",
    "properties": {
      "screen": "string",
      "value_str": "string"
    },
    "namespace": "marketplace"
  },
  "adjusted-filter": {
    "name": "adjusted-filter",
    "class": "interaction",
    "properties": {
      "screen": "string",
      "value_str": "string",
      "filter_type": "string"
    },
    "namespace": "marketplace"
  },
  "selected-search-option": {
    "name": "selected-search-option",
    "class": "interaction",
    "properties": {
      "screen": "string",
      "value_str": "string"
    },
    "namespace": "marketplace"
  },
  "created-asset": {
    "name": "created-asset",
    "class": "interaction",
    "properties": {
      "screen": "string",
      "value_str": "string"
    },
    "namespace": "marketplace"
  },
  "good-info-click": {
    "name": "good-info-click",
    "class": "interaction",
    "properties": {
      "sortBy": {
        "type": "string",
        "isOptional": true
      },
      "provider": {
        "type": "string",
        "isOptional": true
      },
      "INDUSTRY": {
        "type": "string",
        "isOptional": true
      },
      "COS_TEMPLATE_LAYOUT": {
        "type": "string",
        "isOptional": true
      },
      "COS_TEMPLATE_INTENT": {
        "type": "string",
        "isOptional": true
      },
      "COS_TEMPLATE_FEATURES": {
        "type": "array",
        "isOptional": true
      },
      "COS_TEMPLATE_CODING_TYPE": {
        "type": "array",
        "isOptional": true
      },
      "MODULE_COMPATIBILITY": {
        "type": "array",
        "isOptional": true
      },
      "MODULE_PURPOSE": {
        "type": "array",
        "isOptional": true
      }
    },
    "namespace": "marketplace"
  }
};